export const manageusersData = [
  {
    id: 1,
    si_no: "",
    select: "",
    customer_name: "Darlee Robertson",
    image: "assets/img/profiles/avatar-19.jpg",
    customer_no: "Facility Manager",
    phone: "1234567890",
    email: "robertson@example.com",
    location: "Germany",
    created: "25 Sep 2023, 12:12 pm",
    last_activity: "2 mins ago",
    status: "Active",
    Action: "",
    key: "1"
  },
  {
    id: 2,
    si_no: "",
    select: "",
    customer_name: "Sharon Roy",
    image: "assets/img/profiles/avatar-20.jpg",
    customer_no: "Installer",
    phone: "+1 989757485",
    email: "sharon@example.com",
    location: "USA",
    created: "27 Sep 2023, 07:40 am",
    last_activity: "5 mins ago",
    status: "Inactive",
    Action: "",
    key: "2"
  },
  {
    id: 3,
    si_no: "",
    select: "",
    customer_name: "Vaughan",
    image: "assets/img/profiles/avatar-21.jpg",
    customer_no: "Senior  Manager",
    phone: "+1 546555455",
    email: "vaughan12@example.com",
    location: "Canada",
    created: "29 Sep 2023, 08:20 am",
    last_activity: "2 days ago",
    status: "Active",
    Action: "",
    key: "3"
  },
  {
    id: 4,
    si_no: "",
    select: "",
    customer_name: "Jessica",
    image: "assets/img/profiles/avatar-23.jpg",
    customer_no: "Test Engineer",
    phone: "+1 454478787",
    email: "jessica13@example.com",
    location: "India",
    created: "25 Sep 2023, 12:12 pm",
    last_activity: "2 mins ago",
    status: "Active",
    Action: "",
    key: "4"
  },
  {
    id: 5,
    si_no: "",
    select: "",
    customer_name: "Carol Thomas",
    image: "assets/img/profiles/avatar-16.jpg",
    customer_no: "UI /UX Designer",
    phone: "+1 124547845",
    email: "caroltho3@example.com",
    location: "China",
    created: "02 Oct 2023, 10:10 am",
    last_activity: "Online",
    status: "Active",
    Action: "",
    key: "5"
  },
  {
    id: 6,
    si_no: "",
    select: "",
    customer_name: "Dawn Mercha",
    image: "assets/img/profiles/avatar-22.jpg",
    customer_no: "Technician",
    phone: "+1 478845447",
    email: "dawnmercha@example.com",
    location: "Japan",
    created: "17 Oct 2023, 04:25 pm",
    last_activity: "3 days ago",
    status: "Active",
    Action: "",
    key: "6"
  },
  {
    id: 7,
    si_no: "",
    select: "",
    customer_name: "Rachel Hampton",
    image: "assets/img/profiles/avatar-24.jpg",
    customer_no: "Software Developer",
    phone: "+1 215544845",
    email: "rachel@example.com",
    location: "Indonesia",
    created: "28 Oct 2023, 07:16 am",
    last_activity: "10 days ago",
    status: "Active",
    Action: "",
    key: "7"
  },
  {
    id: 8,
    si_no: "",
    select: "",
    customer_name: "Jonelle Curtiss",
    image: "assets/img/profiles/avatar-25.jpg",
    customer_no: "Supervisor",
    phone: "+1 121145471",
    email: "jonelle@example.com",
    location: "Cuba",
    created: "08 Nov 2023, 06:10 am",
    last_activity: "1 week go",
    status: "Active",
    Action: "",
    key: "8"
  },
  {
    id: 9,
    si_no: "",
    select: "",
    customer_name: "Jonathan",
    image: "assets/img/profiles/avatar-26.jpg",
    customer_no: "Team Lead Dev",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    location: "Isreal",
    created: "15 Nov 2023, 11:50 am",
    last_activity: "1 day ago",
    status: "Active",
    Action: "",
    key: "9"
  },
  {
    id: 10,
    si_no: "",
    select: "",
    customer_name: "Brook",
    image: "assets/img/profiles/avatar-01.jpg",
    customer_no: "Team Lead Dev ",
    phone: "+1 278907145",
    email: "brook@example.com",
    location: "Colombia",
    created: "25 Nov 2023, 06:34 pm",
    last_activity: "8 mins ago",
    status: "Active",
    Action: "",
    key: "10"
  },
];
